enum OfferQueryTypesEnum {
  Sent = 'Sent',
  Received = 'Received',
  SentOrReceived = 'SentOrReceived',
}

export default OfferQueryTypesEnum;
